// TintiCloud — Vault & Secrets (valores NUNCA reais). Dados de demonstração.

// Máscara visual fixa — nunca exibir valor real
export const SECRET_MASK = "••••••••••••••••••••••••";

export const SECRET_ENVIRONMENTS = ["Production", "Staging", "Development"];

// Secrets organizados por projeto -> environment. PROJECT é o boundary principal.
export const projectSecrets = {
  cjudi: {
    Production: [
      { id: "cj-p1", name: "DATABASE_URL", versions: 4, updated: "há 3 dias", by: "Luiz Tinti" },
      { id: "cj-p2", name: "JWT_SECRET", versions: 2, updated: "há 12 dias", by: "Luiz Tinti" },
      { id: "cj-p3", name: "MONGO_URL", versions: 3, updated: "há 5 dias", by: "Ana Souza" },
      { id: "cj-p4", name: "STRIPE_SECRET_KEY", versions: 5, updated: "há 2 dias", by: "Bruno Lima" },
    ],
    Staging: [
      { id: "cj-s1", name: "DATABASE_URL", versions: 2, updated: "há 8 dias", by: "Ana Souza" },
      { id: "cj-s2", name: "JWT_SECRET", versions: 1, updated: "há 8 dias", by: "Ana Souza" },
    ],
    Development: [
      { id: "cj-d1", name: "DATABASE_URL", versions: 1, updated: "há 20 dias", by: "Bruno Lima" },
    ],
  },
  smartfolks: {
    Production: [
      { id: "sf-p1", name: "WORDPRESS_DB_PASSWORD", versions: 2, updated: "há 6 dias", by: "Ana Souza" },
      { id: "sf-p2", name: "SMTP_PASSWORD", versions: 3, updated: "há 8 dias", by: "Ana Souza" },
    ],
    Staging: [],
    Development: [],
  },
  moracomigo: {
    Production: [
      { id: "mc-p1", name: "DATABASE_URL", versions: 3, updated: "há 4 dias", by: "Bruno Lima" },
      { id: "mc-p2", name: "STRIPE_SECRET_KEY", versions: 5, updated: "há 2 dias", by: "Bruno Lima" },
    ],
    Staging: [{ id: "mc-s1", name: "STRIPE_SECRET_KEY", versions: 1, updated: "há 10 dias", by: "Bruno Lima" }],
    Development: [],
  },
  tintitech: {
    Production: [{ id: "tt-p1", name: "S3_ACCESS_KEY", versions: 2, updated: "há 5 dias", by: "Ana Souza" }],
    Staging: [],
    Development: [],
  },
  c2desk: { Production: [{ id: "c2-p1", name: "DJANGO_SECRET_KEY", versions: 2, updated: "há 7 dias", by: "Luiz Tinti" }], Staging: [], Development: [] },
  primeagents: { Production: [], Staging: [{ id: "pa-s1", name: "REDIS_URL", versions: 1, updated: "há 15 dias", by: "Bruno Lima" }], Development: [] },
};

export const countProjectSecrets = (id) => {
  const env = projectSecrets[id];
  if (!env) return 0;
  return Object.values(env).reduce((a, arr) => a + arr.length, 0);
};

// Platform Secrets — SOMENTE credenciais da própria infraestrutura TintiCloud.
export const platformSecrets = [
  { id: "pf1", name: "CLOUDFLARE_API_TOKEN", category: "Cloudflare", versions: 1, updated: "há 1 mês", by: "Ana Souza" },
  { id: "pf2", name: "NPM_ADMIN_PASSWORD", category: "Nginx Proxy Manager", versions: 2, updated: "há 20 dias", by: "Luiz Tinti" },
  { id: "pf3", name: "GITHUB_DEPLOY_KEY", category: "Git Provider", versions: 1, updated: "há 20 dias", by: "Luiz Tinti" },
  { id: "pf4", name: "AGENT_BOOTSTRAP_TOKEN", category: "Agent", versions: 3, updated: "há 4 dias", by: "Ana Souza" },
  { id: "pf5", name: "SMTP_INFRA_PASSWORD", category: "E-mail (infra)", versions: 2, updated: "há 9 dias", by: "Ana Souza" },
];

// Legado (usado por telas antigas) — mantido para compatibilidade.
export const secrets = [
  { id: "s1", name: "DATABASE_URL", scope: "project", project: "CJUDI", updated: "há 3 dias", by: "Luiz Tinti", versions: 4 },
  { id: "s2", name: "JWT_SECRET", scope: "project", project: "CJUDI", updated: "há 12 dias", by: "Luiz Tinti", versions: 2 },
  { id: "s4", name: "SMTP_PASSWORD", scope: "project", project: "Smartfolks", updated: "há 8 dias", by: "Ana Souza", versions: 3 },
  { id: "s5", name: "STRIPE_SECRET_KEY", scope: "project", project: "MoraComigo", updated: "há 2 dias", by: "Bruno Lima", versions: 5 },
  { id: "s7", name: "S3_ACCESS_KEY", scope: "project", project: "TintiTech", updated: "há 5 dias", by: "Ana Souza", versions: 2 },
];
